<template>
  <div class="print-sheet-title">
    {{ $t('LBL_NOTES') }}
  </div>
  <div class="print-notes">
    {{ getNotes }}
  </div>
</template>

<script>
import { usePrintStore } from '@/stores/PrintStore';

export default {
  name: 'PrintNotes',
  computed: {
    getNotes () {
      const jobNotes = usePrintStore().getJobNotes;
      return jobNotes == '' ? this.$t('TEXT_SAMPLE_NOTES_HERE') : jobNotes;
    }
  }
};
</script>

<style scoped>
.print-notes-input {
  flex: 1;
  margin: 10px;
}
.print-notes {
  border: .5px solid #231F20;
  font-size: 80%;
  margin-right: 20px;
  padding: 10px;
  flex: 1;
}
</style>